export class DateUtil {
  static extractDateFromDateTime(date: string): Date {
    let pattern = new RegExp(/\d{4}-\d{2}-\d{2}/);
    let result = pattern.exec(date);
    return new Date(result[0]);
  }
}
